import { ArrowRight, ShoppingBag } from "lucide-react";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import bannerImage2 from '../../Assets/Images/HomeBanner/HomeBanner2.jpeg'
import { Link } from "react-router-dom";

// Mobile detection hook
const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return isMobile;
};

const HomeBanner = () => {
    const isMobile = useIsMobile();

    // Motion variants
    const containerVariants = {
        hidden: {},
        visible: { transition: { staggerChildren: 0.15 } },
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: { y: 0, opacity: 1, transition: { duration: 0.6 } },
    };

    return (
        <motion.div
            className="relative w-full"
            initial="hidden"
            animate="visible"
            variants={containerVariants}>
            {/* Banner */}
            <div className="relative w-full h-[60vh] sm:h-[70vh] md:h-[500px] lg:h-[550px] xl:h-[600px] overflow-hidden">
                <img
                    src={bannerImage2}
                    alt="Food Delivery"
                    className={`w-full h-full object-cover opacity-70 ${isMobile ? "object-right" : "object-center"
                        }`}
                />
                {/* <div className="absolute inset-0 bg-gradient-to-br from-orange-600/20 via-red-500/20 to-yellow-500/20 animate-pulse-slow"></div>
                <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-transparent"></div> */}
                <div className="absolute inset-0 bg-black/50"></div>

                {/* Text Overlay */}
                <div className="absolute inset-0 flex flex-col justify-center items-center px-4 sm:px-6 lg:px-8 text-center">
                    <motion.h1
                        className="text-snowtxt text-2xl md:text-5xl font-bold mb-2"
                        variants={itemVariants}>
                        Ordering Made Easy for Students
                    </motion.h1>
                    <motion.h3
                        className="text-snowtxt text-base md:text-lg font-semibold"
                        variants={itemVariants}>
                        Fresh, fast, and reliable food ordering from your goto canteen counter.
                    </motion.h3>
                    <motion.div
                        className="mt-6 sm:mt-8 flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center"
                        variants={itemVariants}>
                        <Link
                            to='/cart'
                            className="flex items-center justify-center bg-redbg text-snowtxt border border-redtxt text-sm md:text-base font-semibold px-8 py-3 rounded-lg shadow-md hover:shadow-lg transition-all hover:bg-red-600">
                            Order Now
                            <ShoppingBag className="ml-2 w-5 h-5" />
                        </Link>
                        <Link
                            to='/restaurants'
                            className="flex items-center justify-center bg-white text-redtxt border border-white text-sm md:text-base font-semibold  px-8 py-3 rounded-lg shadow-md hover:shadow-lg transition-all">
                            Browse Restaurants
                            <ArrowRight className="ml-2 w-5 h-5" />
                        </Link>
                    </motion.div>
                </div>
            </div>
        </motion.div>
    );
};

export default HomeBanner;